import React from 'react';
import { Form, Label } from 'semantic-ui-react';
import {
  channelImageConfigV103,
  hasNativeImageBridgeV103,
  imageResponsePolicyV103,
} from './imageResponseConfigV103';

export default function ImageResponsePolicyV103({
  type,
  groups,
  config,
  onChange,
  t,
}) {
  const label = (name) => t(`image_response_v103.${name}`);
  return (
    <section aria-label={label('title')}>
      <Form.Dropdown
        fluid
        selection
        label={label('processing')}
        aria-label={label('processing')}
        name='image_response_processing_v103'
        value={
          { basic: 'passthrough', full: 'validate' }[
            config.image_response_processing_v103
          ] ||
          config.image_response_processing_v103 ||
          'passthrough'
        }
        options={['passthrough', 'local', 'validate'].map((value) => ({
          key: value,
          value,
          text: label(value),
        }))}
        onChange={onChange}
      />
      <Form.Dropdown
        fluid
        selection
        label={label('formats')}
        aria-label={label('formats')}
        name='image_response_formats_v103'
        value={config.image_response_formats_v103 || 'unrestricted'}
        options={['unrestricted', 'both', 'b64_json', 'url'].map((value) => ({
          key: value,
          value,
          text: label(value),
        }))}
        onChange={onChange}
      />
      {hasNativeImageBridgeV103(type, groups, config) && (
        <Label basic size='small' color='teal'>
          {label('native_bridge')}
        </Label>
      )}
    </section>
  );
}

export function ChannelImageResponseBadgesV103({ channel, t }) {
  let config;
  let policy;
  try {
    config = channelImageConfigV103(channel);
    policy = imageResponsePolicyV103(config);
  } catch {
    return (
      <Label basic color='red' size='tiny'>
        {t('image_response_v103.invalid_policy')}
      </Label>
    );
  }
  const labels = [];
  if (policy.processing === 'local') labels.push('local_badge');
  if (policy.processing === 'validate') labels.push('validate_badge');
  labels.push(policy.formats);
  if (hasNativeImageBridgeV103(channel.type, channel.group, config))
    labels.push('native_bridge');
  return labels.map((name) => (
    <Label basic size='tiny' key={name} style={{ marginLeft: '4px' }}>
      {t(`image_response_v103.${name}`)}
    </Label>
  ));
}
